module.exports = __webpack_public_path__ + "static/characters-c41ad5074c7cc12a92f7511d170bd985.png";